import React from 'react';
import MokaArrow from 'assets/images/start-using-moka-arrow.png';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Logo from '../Logo';
import styles from './AppRow.css';

class AppRow extends React.PureComponent {
  render() {
    const { app, business, defaultStyle } = this.props;
    const shortDescriptionStyle = defaultStyle
      ? styles.appMarketPlaceShortDescription
      : styles.myAppShortDescription;
    return (
      <div className={`row ${styles.wrapper}`}>
        <div className={`col-xs-12 no-padding ${styles.appContainer}`}>
          <div className={styles.column}>
            <div className={styles.leftColumn}>
              <Logo
                src={app.logo.url || 'http://via.placeholder.com/350x350'}
              />
              {!defaultStyle && !!this._showLearnMore() && (
                <div className={styles.learnMoreWrapper} />
              )}
            </div>
            <div className={styles.rightColumn}>
              <div className={styles.appHeader}>
                <div className={styles.appTitle}>{app.name}</div>
                {!defaultStyle && (
                  <a
                    className={`btn btn-default btn-outline-primary ${styles.myappLaunchBtn}`}
                    onClick={this._onClickLaunch}
                  >
                    {this.props.launchText}
                  </a>
                )}
              </div>
              <div className={shortDescriptionStyle}>
                <p>{app.short_description}</p>
              </div>
              <hr className={styles.footerLineSeparator} />
              {!defaultStyle && (
                <div className={styles.myAppFooter}>
                  <div className={styles.outletInformation}>
                    <b>{business.name}</b> ({business.outlet_count} Outlets)
                  </div>
                  {this.renderRevokePermission(!defaultStyle)}
                </div>
              )}
            </div>
          </div>
          {defaultStyle && (
            <div className={styles.appMarketPlaceFooter}>
              <div className={styles.findOutMoreButton}>
                <Link
                  to={`/apps/${app.id}/learn-more`}
                  onClick={this._onClickLearnMore}
                >
                  Find out more
                  <img className={styles.arrowIcon} src={MokaArrow} />
                </Link>
              </div>
              <button
                className={this.props.launchCss}
                onClick={this._onClickLaunch}
              >
                {this.props.launchText}
              </button>
              {this.renderRevokePermission(defaultStyle)}
            </div>
          )}
        </div>
      </div>
    );
  }

  renderRevokePermission(usingDefaultStyle) {
    const displayTxt = usingDefaultStyle ? (
      <i className="fa fa-times" />
    ) : (
      'Revoke Permission'
    );
    return (
      <span>
        {!!this._showRemove() && (
          <a
            className={styles.btnRemove}
            onClick={this._onClickRemove}
            href="#"
          >
            {displayTxt}
          </a>
        )}
      </span>
    );
  }

  _showRemove = () => {
    return !!this.props.onClickRemove;
  };

  _onClickRemove = () => {
    this.props.onClickRemove({ app: this.props.app });
  };

  _showLearnMore = () => {
    return !!this.props.onClickLearnMore;
  };

  _onClickLearnMore = () => {
    this.props.onClickLearnMore({ app: this.props.app });
  };

  _onClickLaunch = () => {
    this.props.onClickLaunch({ app: this.props.app });
  };
}

AppRow.propTypes = {
  app: PropTypes.object,
  onClickRemove: PropTypes.func,
  onClickLearnMore: PropTypes.func,
  onClickLaunch: PropTypes.func,
  launchText: PropTypes.string,
  launchCss: PropTypes.string,
  business: PropTypes.object,
  // default styles - styles from the app marketplace
  defaultStyle: PropTypes.bool,
};

AppRow.defaultProps = {
  launchText: 'Get Started',
  launchCss: 'btn btn-primary',
};

export default AppRow;
